<template>
  <!-- 列表组件 -->
  <div class="insurancelist">
    <div v-if="isShow">
      <div
        class="hasData"
        v-for="item in list"
        :key="item.id"
        @click="chooseItem(item)"
      >
        <el-row class="content-top">
          <el-col :span="6">
            <div>
              检测明细编号:
              {{ item.food_check_item_id ? item.food_check_item_id : "--" }}
            </div>
          </el-col>
          <el-col :span="6">
            <div>
              食品检测编号:
              {{ item.food_check_id ? item.food_check_id : "--" }}
            </div>
          </el-col>
        </el-row>
        <div class="content">
          <el-row class="content-first">
            <el-col :span="2">
              <div class="item1">
                {{ item.check_project_type || "--" }}
              </div>
            </el-col>
            <el-col :span="9">
              <div class="item2">{{ item.check_project || "--" }}</div>
            </el-col>
            <el-col :span="5">
              <div class="item3">
                检测依据 : {{ item.check_standard || "--" }}
              </div>
            </el-col>
            <el-col :span="4" class="item5">{{
              item.update_time || "--"
            }}</el-col>
            <el-col :span="4">
              <div
                class="item4"
                :class="
                  item.item_verdict_id == 1
                    ? 'green-color'
                    : item.item_verdict_id == 2
                    ? 'red-color'
                    : ''
                "
              >
                {{
                  item.item_verdict_id == 1
                    ? "合格"
                    : item.item_verdict_id == 2
                    ? "不合格"
                    : "--"
                }}
              </div>
            </el-col>
          </el-row>
          <div class="content-last">
            <div class="last-left">
              <el-row class="left-info">
                <el-col :span="3">
                  <div>标准值:{{ item.standard_value || "--" }}</div>
                </el-col>
                <el-col :span="4">
                  <div>
                    实测值:<span
                      :class="
                        Number(item.result_value) > Number(item.standard_value)
                          ? 'red-color'
                          : 'green-color'
                      "
                      >{{ item.result_value || "--" }}</span
                    >
                  </div>
                </el-col>
                <el-col :span="10">
                  <div>质量单位:{{ item.unit || "--" }}</div>
                </el-col>
              </el-row>
              <el-row class="remark">备注:{{ item.remark || "--" }}</el-row>
            </div>
            <div class="last-rigt" @click="showInspectionResult(item)">
              <img src="~@/assets/images/common/result.png" alt="" />
              <span>检测结果报告</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 无数据 -->
    <div class="noDataImg" v-else>
      <div class="imgNo">
        <img src="~@/assets/images/qualityInspection/no-data.png" alt="" />
      </div>
    </div>

    <!-- 遮罩层 -->
    <div class="mask" v-show="showMask">
      <div class="result-report" v-if="showMask">
        <div class="report-info" id="inspectionReport">
          <div class="info-top">
            <div class="top-left">
              {{ pdfInfo.sample_adress }}农产品质量监督站
            </div>
            <div class="top-right">
              <p>NO.{{ pdfInfo.food_check_id }}</p>
              <p>数据支持： {{ thirdCompany }}</p>
            </div>
          </div>
          <div class="info-content">
            <div class="content-top">检测结果报告</div>
            <div class="content">
              <div class="left">
                <span>品种/名称</span>
                <span>Sample/Description</span>
              </div>
              <div class="right">{{ pdfInfo.sample_name }}</div>
            </div>
            <div class="content">
              <div class="left">
                <span>检测项目</span>
                <span></span>
              </div>
              <div class="right">{{ pdfInfo.check_project }}</div>
            </div>
            <div class="content">
              <div class="left">
                <span>产地/基地</span>
                <span>Manufacturer</span>
              </div>
              <div class="right">{{ pdfInfo.habitat_name }}</div>
            </div>
            <div class="content">
              <div class="left">
                <span>受（委）检单位</span>
                <span>Inspected Entity</span>
              </div>
              <div class="right">{{ pdfInfo.producer }}</div>
            </div>
            <div class="content">
              <div class="left">
                <span>抽（送）样基数</span>
                <span>Sampling Population</span>
              </div>
              <div class="right">{{ pdfInfo.send_base_num }}</div>
            </div>
            <div class="content">
              <div class="left">
                <span>抽（送）样日期</span>
                <span>Application Date</span>
              </div>
              <div class="right" v-if="pdfInfo.send_date">
                {{ pdfInfo.send_date | formatDate("yyyy年MM月dd日") }}
              </div>
              <div class="right" v-else></div>
            </div>
            <div class="content">
              <div class="left">
                <span>抑制率</span>
                <span>Ref.Documents for the Test</span>
              </div>
              <div class="right">
                {{ pdfInfo.rate + "%" || "--" }}
              </div>
            </div>
            <div class="content inspection-text">
              <div class="left">
                <span>检测结果</span>
                <span>Test Conclusion</span>
              </div>
              <div class="right">
                {{ qualityResult ? "不合格" : "合格" }}
              </div>
            </div>
            <p class="inspection">
              检测环境（Environmental condication during testing：30˚C 60%RH）
            </p>
            <div class="content">
              <div class="left">
                <span>检验</span>
                <span>Tested by</span>
              </div>
              <div class="right">{{ pdfInfo.check_user }}</div>
            </div>
            <div class="content">
              <div class="left">
                <span>复核</span>
                <span>Inspected by</span>
              </div>
              <div class="right"></div>
            </div>
            <div class="content">
              <div class="left">
                <span>批准</span>
                <span>Approved by</span>
              </div>
              <div class="right"></div>
            </div>
            <div class="content">
              <div class="left">
                <span>检验日期</span>
                <span>Test Date</span>
              </div>
              <div class="right" v-if="pdfInfo.check_date">
                {{ pdfInfo.check_date | formatDate("yyyy年MM月dd日") }}
              </div>
              <div class="right" v-else></div>
            </div>
          </div>
        </div>
        <div class="report-btn">
          <el-button size="small" round @click="exportPDF(pdfInfo)"
            >导出PDF</el-button
          >
          <el-button type="primary" size="small" round @click="closeEvent">
            关闭</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import html2Canvas from "html2canvas";
import { qualityInspection } from "@/api/request/snkd.produce";
import JsPDF from "jspdf";
export default {
  name: "TableList",
  data() {
    return {
      isSelect: null,
      showMask: false,
      pdfInfo: {},
      qualityResult: "",
      thirdCompany: "",
    };
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.thirdCompany = this.$route.query.thirdCompany;
    console.log("11111111", 0 > "");
    console.log("222222", 0 > null);
  },

  computed: {},

  methods: {
    //跳转详情页
    chooseItem(item) {
      this.$router.push({
        name: "QualityResultDetailList",
        query: {
          type: 1,
          id: item.food_check_id,
        },
      });
    },
    //获取项目明细数据
    async getDetailServe(id) {
      this.loading = true;
      const { respCode, obj } =
        await qualityInspection.getQualityResultDetailListServe({
          id: id,
        });
      if (respCode === 0) {
        if (obj.length) {
          this.pdfInfo = obj[0];
          this.qualityResult = obj.find((item) => {
            return item.check_verdict == "不合格";
          });
        }
        this.loading = false;
      }
    },
    //打开结果检测报告弹框
    async showInspectionResult(info) {
      var ev = window.event || arguments.callee.caller.arguments[0];
      if (window.event) {
        ev.cancelBubble = true; // 只执行子层方法
      } else {
        ev.stopPropagation(); // 阻止事件冒泡
      }
      await this.getDetailServe(info.food_check_id);
      this.showMask = true;
    },
    //关闭弹框
    closeEvent() {
      this.showMask = false;
    },
    //导出PDF
    exportPDF(info) {
      const name = this.thirdCompany;
      const result = new Promise((resolve) => {
        html2Canvas(document.querySelector("#inspectionReport"), {
          allowTaint: false,
          useCORS: true,
          imageTimeout: 0,
          dpi: 300,
          scale: 4,
        }).then(function (canvas) {
          let pageData = canvas.toDataURL("image/jpeg", 1),
            canvasWidth = canvas.width,
            canvasHeight = canvas.height,
            concentWidth = 320,
            concentHeight = Math.round(
              (concentWidth / canvasWidth) * canvasHeight
            ),
            position = 72,
            pageHeight = 840,
            height = concentHeight;
          let PDF = new JsPDF("p", "px", "a4");
          if (height <= pageHeight) {
            // 添加图片
            PDF.addImage(
              pageData,
              "JPEG",
              68,
              position,
              concentWidth,
              concentHeight
            );
          } else {
            while (height > 0) {
              PDF.addImage(
                pageData,
                "JPEG",
                68,
                position,
                concentWidth,
                concentHeight
              );
              height -= pageHeight;
              position -= pageHeight;
              if (height > 0) {
                PDF.addPage();
              }
            }
          }
          PDF.save(
            `快检结果-${name}-${info.food_check_id}-(${
              parseInt(new Date().getTime()) + ""
            }).pdf`
          );
          resolve(true);
        });
      });
      this.showMask = false;
      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
.insurancelist {
  // background-color: palegoldenrod;
}

.red-color {
  color: #ff4d4f !important;
}

.green-color {
  color: #38af1f !important;
}

.noDataImg {
  img {
    transform: scale(0.7);
  }
}

.mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 5;
}

.hasData {
  height: 200px;
  width: 100%;
  box-shadow: 0px 5px 20px rgba(85, 85, 124, 0.13);
  border-radius: 20px;
  margin-bottom: 20px;
  padding: 0px 24px;
  box-sizing: border-box;

  .content-top {
    height: 46px;
    line-height: 46px;
    color: #666;
    font-size: 14px;
    border-bottom: 1px solid #eaeef4;
  }

  .content {
    margin-top: 17.5px;
    color: #999;
    font-size: 12px;

    .content-first {
      height: 29px;
      line-height: 29px;

      .item1 {
        text-align: center;
        width: 66px;
        background: #f7f9fb;
        color: #999;
        font-size: 12px;
        border-radius: 10px;
      }

      .item2 {
        font-size: 20px;
        color: #333;
      }

      .item3 {
        text-align: left;
        font-size: 14px;
        width: 227px;
        overflow: hidden !important;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .item5 {
        text-align: right;
        font-size: 14px;
      }

      // .time-style {
      //   height: 200px;
      //   margin-left: 40px;
      // }
      .item4 {
        float: right;

        font-style: normal;
        font-weight: 500;
        font-size: 22px;
        line-height: 29px;
        font-size: 22px;
      }
    }

    .content-last {
      margin-top: 10px;
      margin-left: 80px;
      font-size: 14px;
      color: #666;

      .last-left {
        width: 822px;
        padding-left: 10px;

        .left-info {
          height: 35px;
          line-height: 35px;
          background: #f7f9fb;

          span {
            display: inline-block;
            margin-right: 40px;
          }
        }

        .remark {
          margin-top: 10px;
        }
      }

      .last-rigt {
        position: relative;
        bottom: 40px;
        text-align: center;
        float: right;
        width: 56px;
        height: 56px;
        background: #eefff9;
        font-size: 10px;
        line-height: 13px;
        color: #64c3a4;
        border: 0.5px solid #64c3a4;
        border-radius: 8px;
        cursor: pointer;

        img {
          width: 20px;
          height: 20px;
        }

        span {
          display: inline-block;
        }
      }
    }
  }

  &:hover {
    border: 1px solid #64c3a4;
  }
}

.result-report {
  height: 780px;
  width: 600px;
  position: absolute;
  bottom: 40px;
  left: 35%;
  z-index: 10;
  background-color: #fff;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.25);
  border-radius: 10px;

  .report-info {
    margin: 0 auto;
    margin-top: 15px;
    width: 570px;
    height: 715px;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.25);
    color: #999999;

    .info-top {
      padding: 0px 10px;
      box-sizing: border-box;
      height: 60px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      border-bottom: 1px solid #eee;
      margin-bottom: 15px;

      .top-left {
        width: 340px;
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        color: #333333;
        overflow: hidden;
        word-break: break-all;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
      }

      .top-right {
        // height: 60px;
        width: 250px;
        text-align: right;
        font-weight: 400;
        font-size: 11px;
        line-height: 15px;

        p {
          overflow: hidden;
          word-break: break-all;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
        }
      }
    }

    .info-content {
      padding: 0 10px;
      height: 640px;

      .content-top {
        font-style: normal;
        font-weight: 700;
        font-size: 20px;
        line-height: 26px;
        text-align: center;
        color: #333333;
      }

      .content {
        box-sizing: border-box;
        height: 48px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-weight: 400;
        font-size: 12px;
        line-height: 14px;
        color: #666666;

        .left {
          span {
            display: block;
          }

          span:nth-child(2) {
            color: #999;
          }
        }

        .right {
          height: 50px;
          line-height: 50px;
          text-align: center;
          width: 235px;
          border-bottom: 1px solid #838383;
        }
      }

      .inspection {
        width: 395px;
        font-size: 12px;
        line-height: 12px;
      }

      .inspection-text {
        height: 44px;

        .right {
          height: 40px;
          line-height: 40px;
        }
      }
    }
  }

  .report-btn {
    height: 40px;
    margin-top: 10px;
    text-align: center;
  }
}
</style>
